import cn from 'classnames';
import React, {useEffect, useState} from 'react';
import {CopyToClipboard} from 'react-copy-to-clipboard';

import Popup from '@/components/Popup/Popup';
import appConfig from '@/config/appConfig.typed';
import appService from '@/services/appService';
import logState from '@/services/logger/logState';
import routerService from '@/services/route/routerService';
import {
    showConsumerFeedbackGatheringModalAction,
    showNewBadgePopup,
    showNextJourneyLevelTaskPopup,
} from '@/state/slices/modalSlice';
import {dispatch} from '@/state/store';

import {FirmwareUpdateTest} from './FirmwareUpdate';
import styles from './Logs.module.css';
import SubscriptionInfo from './SubscriptionInfo';

const Logs = () => {
    const [isVisibleLogs, setIsVisibleLogs] = useState(false);
    const [logs, setLogs] = useState(null);

    const onLogsOpen = () => {
        setLogs(logState.getLogState());
        setIsVisibleLogs(true);
    };
    const onLogsClose = () => setIsVisibleLogs(false);

    const clearLogs = () => {
        setLogs(null);
        logState.clearLogState();
        onLogsClose();
    };

    const title = appConfig.getAppVersion();

    const showFeedbackModal = () => {
        dispatch(showConsumerFeedbackGatheringModalAction());
        onLogsClose();
    };

    const openFirmwareInfo = () => {
        routerService.forwardTo('/devices/firmware-info');
        onLogsClose();
    };

    const openNextTaskPopup = () => {
        dispatch(showNextJourneyLevelTaskPopup());
    };

    const openNewBadgePopup = () => {
        dispatch(showNewBadgePopup());
    };

    // TODO: Remove temp
    useEffect(() => {
        if (isVisibleLogs) {
            appService.fetchLoyaltyJourneys();
        }
    }, [isVisibleLogs]);

    return (
        <>
            <div id='logs' className={styles.LogsIcon} onClick={onLogsOpen} aria-hidden='true'>
                {title}
            </div>
            {isVisibleLogs && (
                <Popup onClose={onLogsClose} overlayClassName={styles.LogsPopupOverlay} className={styles.LogsPopup}>
                    {isVisibleLogs && (
                        <>
                            <div>
                                <button onClick={clearLogs} className={styles.ClearLogsBtn}>
                                    Clear logs
                                </button>
                                <CopyToClipboard text={logs?.map(({log}) => log).join('\n')}>
                                    <div className={styles.ClearLogsBtn}>Copy logs</div>
                                </CopyToClipboard>
                                <button onClick={showFeedbackModal} className={cn(styles.ClearLogsBtn, 'bg-tertiary')}>
                                    Feedback
                                </button>
                                <button onClick={openFirmwareInfo} className={cn(styles.ClearLogsBtn, 'bg-tertiary')}>
                                    Open FirmwareInfo
                                </button>
                                <button onClick={openNextTaskPopup} className={cn(styles.ClearLogsBtn, 'bg-tertiary')}>
                                    Open next task popup
                                </button>
                                <button onClick={openNewBadgePopup} className={cn(styles.ClearLogsBtn, 'bg-tertiary')}>
                                    Open new badge popup
                                </button>
                            </div>
                            <SubscriptionInfo />
                            <FirmwareUpdateTest />
                            <div className='mt-4'>
                                {logs?.map(({log}, i) => {
                                    return (
                                        <div className={styles.LogContainer} key={i}>
                                            <div className={styles.Log}>{log}</div>
                                        </div>
                                    );
                                })}
                            </div>
                        </>
                    )}
                </Popup>
            )}
        </>
    );
};

export default Logs;
